module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.newNotifications)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    class: {
      active: _vm.tab === 'new'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab($event, 'new')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    class: {
      active: _vm.tab === 'old'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab($event, 'old')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Old")])])])]), _vm._v(" "), _c('li', [(_vm.tab === 'new') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.newNotifications), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.newNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("There are no new notifications")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.tab === 'old') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.oldNotifications), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.oldNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("There are no old notifications")])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.newNotifications.length && _vm.tab === 'new') ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.markAllAsRead
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Mark all as read")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6aac0a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NotificationsMenu.vue
// module id = 664
// module chunks = 1